<div class="card">
  <p-table [value]="userInfoKeys" size="small" [tableStyle]="{ 'min-width': '100%' }">
      <ng-template #body let-key>
          <tr>
            <td><strong>{{ getTranslatedKey(key) }}</strong></td>
            <td>{{ getTranslatedValue(key) }}</td>
          </tr>
      </ng-template>
  </p-table>
</div>